export const BRANDS_FORMATTED = {
  zillow: 'Zillow',
  hotpads: 'HotPads',
} as const;
